<template>
<div class="card">


<div class="row clearfix">

    <div class="col-lg-12 col-md-12 col-sm-12">
      <!-- <dev-action-line-item-group v-bind:typeData="typeOfBtn" /> -->
      <router-view v-bind:typeData="typeOfBtn" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="body">
        <div class="list-group">
         
        </div>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
// import DevActionLineItemGroup from '@/views/dev/action/DevActionLineItemGroup';
import eventbus from "@/store/modules/devEventBus";

export default {
  components: { 
    // DevActionLineItemGroup : DevActionLineItemGroup,
    // DevActionLineItemGroup: () =>
    //   import("@/views/dev/action/DevActionLineItemGroup"),
    // DevActionLineItemKeyLabel: () =>
    //   import("@/views/dev/action/DevActionLineItemKeyLabel"),
  },
  props: ["typeData"],
  data() {
    return {
      types: "",
      forSearch: false,

      whichComp : "",

      // listlist: [],
      groupList: { key: "", label: "" },

      typeOfBtn: "inputlineItem",
    };
  },
  methods: {
    changeActionType(num) {
      if (num == 1) {
        this.forSearch = true;
      } else {
        this.forSearch = false;
      }
    },
  },
  name: "DevActInputLineItemGroupFrame",
  created() {


    eventbus.$on("KeyValueComponent", ()=>{
  
      this.whichComp = "DevActionLineItemKeyLabel"

 
    })

    eventbus.$on("GroupComponent", ()=>{
  
      this.whichComp = "DevActionLineItemGroup"

 
    })



    console.log("DevActInputLineItemGroupFrame.created");

    console.log(this.typeData);
    console.log(this.$store.state.devStore.apiSchema);


    eventbus.$on("listlist", (res) => {
      this.listlist.push(res);

      this.$store.state.devStore.lineItem = this.listlist;

      console.log(this.listlist);

      eventbus.$off("listlist");
    });

    eventbus.$on("grouplist", (res) => {
      console.log(res.get("key"));
      this.groupList.key = res.get("key");
      this.groupList.label = res.get("label");

      this.$store.state.devStore.lineGroup.keys = this.groupList.key;
      this.$store.state.devStore.lineGroup.label = this.groupList.label;

      console.log("체크: ", this.$store.state.devStore.lineGroup);
      console.log(this.groupList);
      console.log(this.$store.state.devStore.lineGroup);
    });

    eventbus.$emit("fieldNum", 2);


    this.whichComp = 'DevActionLineItemGroup'

  },
  mounted() {
    console.log("DevActInputLineItemGroupFrame.mounted");
  },
  beforeDestroy() {
    console.log("DevActInputLineItemGroupFrame.beforeDestroy");

    eventbus.$off("listlist");
    eventbus.$off("menuSetted");
        eventbus.$off("GroupComponent")
        eventbus.$off("KeyValueComponent")


    console.log("삭제 함 ");
    this.$store.state.devStore.lineGroup = { key: "", label: "" };
    this.$store.state.devStore.lineItem = [];
    this.$store.state.devStore.reMenu = 0;
  }
}
</script>
